import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/skytree.webp';
import screenshot_target from '../../../images/letterfunnel/robvanstraten.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Rob van Straten"
      firstname="Rob"
      companyname="Skytree"
      competition="Climeworks en Carbyon"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/robvanstraten.js